import { storyblokEditable } from "@storyblok/react";
import Image from "next/image";
import { sbBlok } from "../../types/sb-types";
import Cta from "../Cta";
import GridElement from "../GridElement";
import GridWrapper from "../GridWrapper";
import styles from "./HeroText.module.css";
import {
  NODE_PARAGRAPH,
  NODE_UL,
  NODE_OL,
  NODE_LI,
  NODE_HEADING,
  render,
} from "storyblok-rich-text-react-renderer";

interface HeroTextProps {
  blok: sbBlok;
}

const HeroText = ({ blok }: HeroTextProps) => {
  const { cta_link, cta_link_name, content, content_text, image } = blok;

  return (
    <section className={styles.heroText} {...storyblokEditable(blok)}>
      <GridWrapper>
        <GridElement
          className={styles.heroTextGridImg}
          gridLayout={[
            [0, 1, 4, 1],
            [961, 6, 11, 1],
            [1401, 17, 16, 1],
          ]}
        >
          {image?.filename && (
            <div className={styles.heroTextBgImg}>
              <Image
                src={image.filename}
                alt={image.alt}
                layout="responsive"
                width={1000}
                height={1000}
                objectFit="cover"
              />
            </div>
          )}
        </GridElement>
        <GridElement
          className={styles.heroTextGridContent}
          gridLayout={[
            [0, 1, 4, 1],
            [961, 5, 8, 1],
            [1401, 10, 14, 1],
          ]}
        >
          <div className={styles.heroTextContent}>
            {content_text &&
              render(content_text, {
                nodeResolvers: {
                  [NODE_PARAGRAPH]: (children) => <p>{children}</p>,
                  [NODE_UL]: (children) => (
                    <ul className="pl-16 list-disc">{children}</ul>
                  ),
                  [NODE_OL]: (children) => (
                    <ol className="pl-16 list-decimal">{children}</ol>
                  ),
                  [NODE_LI]: (children) => (
                    <li className="mb-6 last:mb-0">{children}</li>
                  ),
                  [NODE_HEADING]: (
                    children,
                    props: { level: 1 | 2 | 3 | 4 | 5 | 6 }
                  ) => {
                    if (props?.level === 1) return <h1>{children}</h1>;

                    if (props?.level === 2) return <h2>{children}</h2>;

                    return <span>{children}</span>;
                  },
                },
              })}
            {content.length > 0 &&
              content.map((p: sbBlok) => <p key={p._uid}>{p.content}</p>)}
            {(cta_link?.url?.length > 0 ||
              cta_link?.story?.slug?.length > 0) && (
              <Cta
                href={cta_link?.url}
                fullSlug={cta_link?.story?.full_slug}
                name={cta_link_name}
                style={{ margin: "4rem auto 0" }}
              />
            )}
          </div>
        </GridElement>
      </GridWrapper>
    </section>
  );
};

export default HeroText;
